import type { App, ComponentPublicInstance } from 'vue'

function getComponentName(instance: ComponentPublicInstance | null): string | undefined {
  if (!instance) {
    return undefined
  }
  const type = instance.$options as { name?: string; __name?: string; __file?: string }
  return type?.name || type?.__name || type?.__file
}

export function installVueErrorHandler(app: App): void {
  app.config.errorHandler = (err, instance, info) => {
    console.error(err)
    try {
      if (window.Bugsnag?.notify) {
        const componentName = getComponentName(instance)
        window.Bugsnag.notify(err as Error, (event: { addMetadata: (section: string, data: Record<string, unknown>) => void }) => {
          event.addMetadata('vue', { info, componentName })
        })
      }
    } catch {
      // Never re-throw from errorHandler — would re-enter Vue's error pipeline.
    }
  }
}